/*
  drayki v3 — home.js : les moments propres à l'accueil (module ES).

  Ce que c'est : le <script> de la page d'accueil de la maquette (pas le
  script de tête, qui est le snippet theme-init), porté en module chargé
  par les sections de l'accueil (<script type="module">, exécuté une seule
  fois même si plusieurs sections le demandent). Il ajoute à drayki.js :
  la phrase ajustée et découverte, son objet qui se couche quand la page
  part et le carrousel qui repart seul après la main (section « hero »),
  la dalle HALO qui se décompose au passage (section « halo »), et le
  dessin de subforge (DRAYKI.DRAW.sf, ajouté dès l'évaluation du module,
  avant le démarrage du système au DOMContentLoaded ; section « deal »).

  Source : C:/Users/DRAYKI/AppData/Local/Temp/claude/X--Downloads-theme-export--drayki-com-draki-23-09--23SEP2026-0445pm/416b7db1-6e6f-4f05-8b03-825cec1c533f/scratchpad/site/index.html
           lignes 605–859 (le <script> de la page)
  Date     : 2026-09-27 01:58:15 +0200 (maquette, round 7)
  SHA-256  : 5705d5c53970578304440b8d05622d94bd47d6b5c474c6fef078ebd577966b0d (index.html entier)

  Le reste est celui de la maquette, ligne pour ligne ; chaque changement
  fait pour le thème est marqué « THEME: » :
  - DRAYKI.section('hero' | 'halo' | 'deal', init) au lieu d'une seule
    section 'home' lancée sur le document : chaque init travaille dans sa
    portée (le document au démarrage, la section rechargée dans l'éditeur)
    et ne monte jamais deux fois le même élément ;
  - les adresses des photos de la vue éclatée viennent de la carte
    imprimée par la section halo-plate (script[data-halo-x]) : le dossier
    assets de Shopify est à plat et ses adresses sont celles du CDN ;
  - la face de la dalle éclatée est la photo d'où les pièces sont tirées
    (halo-x-s1-*), mise dans l'<img> avant que le système ne l'adopte ;
  - le lien « latest release » vise le titre de la carte par sa classe ;
  - une section retirée dans l'éditeur rend son minuteur et son guet.
*/
/*
  The home's own moments, on the system's engine (DRAYKI.register): the
  phrase (fitted to its column, uncovered as the page opens), its object
  lying back as the page leaves it (and going round the kits again once a
  hand has let it go), halo's slab coming apart, and subforge's drawing.
  Every other block is the system's own.
  (The exploded view is page code: the system's object has no parts. Its
  plates live in the slab's .kit-obj, its sockets in the face's .kit-fc,
  sized in cqi — never px inside an object.)
*/
(() => {
  'use strict';
  const W = window, doc = document, root = doc.documentElement, D = W.DRAYKI;
  if (!D || !D.section) return;
  const $ = (s, r = doc) => r.querySelector(s);
  const $$ = (s, r = doc) => Array.from(r.querySelectorAll(s));
  const clamp = (x, a, b) => (x < a ? a : x > b ? b : x);
  const seg = (x, a, b) => clamp((x - a) / (b - a), 0, 1);
  const ease = (u) => (u < .5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2);
  const smooth = (u) => u * u * (3 - 2 * u);
  const lerp = (a, b, t) => a + (b - a) * t;
  // THEME: what a section's init works on — the elements under its scope
  // (the document at the start, the section in the theme's editor), the
  // scope itself included
  const within = (scope, sel) => (scope && scope.nodeType === 1 && scope.matches(sel) ? [scope] : []).concat($$(sel, scope || doc));

  // THEME: the exploded view's photographs, by their original names
  // ("s1-105", "p-a-s1-105", "p-fx4-s1-200"…), as the section halo-plate
  // prints them (<script type="application/json" data-halo-x>: each name
  // and its asset_url). The script never builds an address.
  function haloX(el) {
    const box = el.closest('.shopify-section') || el.closest('section') || doc;
    const s = $('script[data-halo-x]', box) || $('script[data-halo-x]');
    if (!s) return {};
    if (!s._x) { try { s._x = JSON.parse(s.textContent) || {}; } catch (err) { s._x = {}; } }
    return s._x;
  }

  // HALO, coming apart: the parts of its landing's exploded view, where each
  // lies on the face (in the 1200 x 742 frame their photographs were cut
  // from: the landing's own zones) and how far each rises, in hundredths
  // of the slab's width — the effects low, B, A a little over it, the orb
  // highest. Wide: the landing's pose and lifts; a phone: the slab turned
  // less (it stays wide), its parts a little higher than wide (they read
  // at that size), below the landing's phone lifts. (r7: the orb a step
  // over A only, the top of the staircase just clear of A's corner rather
  // than hanging off the slab's; lower, it went behind that corner. And
  // its shadow on the face, the landing's.)
  const FW = 1200, FH = 742;
  const X3 = { fx0: [12, 548, 206, 134], fx1: [247, 548, 206, 134], fx2: [481, 548, 206, 134], fx3: [715, 548, 206, 134], fx4: [950, 548, 206, 134], b: [16, 325, 775, 202], a: [16, 64, 775, 202] };
  const X3_ORB = [4.4, -1.6, 65.4, 65.4];   // the orb's box (26.2, 20.2, 21.8), laid out at three times its size and drawn at a third: it grows as it rises
  const X3_ORBS = [9.1, 3.1, 56, 56];       // the round spot it leaves and its shadow, round the orb's centre (37.1, 31.1): the landing's
  const X3_LIFT = { wide: { fx: 6, b: 10.5, a: 12.5, orb: 13.5 }, tall: { fx: 7, b: 12, a: 14.5, orb: 15.5 } };
  const X3_POSE = { wide: { rx: 47, ry: 0, rz: -17 }, tall: { rx: 42, ry: 0, rz: -5 } };
  const X3_SC = [.8, 1.05, 1.4, 2];         // the plates' photographs, in frame widths (assets/halo-x)
  const PT = 1.2;                           // a part's thickness (cqi)
  // (a part at home: a hair over the face, its face on its body)
  const HOME = 'translate3d(0,0,calc(var(--d) / 2 + .05cqi))', FLUSH = 'translate3d(0,0,0)';
  // (r8) where WebKit draws the page (Safari, any iPhone browser): see
  // "x3-wk" in the style
  const UA = navigator.userAgent || '';
  const WK = /iPhone|iPad|iPod/.test(UA) || (/Macintosh/.test(UA) && navigator.maxTouchPoints > 1) || (/AppleWebKit/.test(UA) && !/Chrome|Chromium|Edg\/|Firefox/.test(UA));
  // (r8) the exploded view is read through a speed cap: its progress (c, in
  // screens) never moves more than X3_RATE screens a second, so a fast
  // flick — iOS momentum above all — never jumps it from whole to apart:
  // the parts take a third of a second at least to lift (HALO's landing:
  // a minimum duration). Off the screen it follows at once.
  const X3_RATE = 1.5;
  // (r8, drayki: "quand il se démonte : les boîtes des sources A et B ne
  // sont pas des vraies boîtes, il y a du vide entre les deux rectangles")
  // A part's walls: thin planes standing round its rounded outline, from its
  // body up to its face, as deep as the part is thick at that moment, each
  // shaded by its angle to the room's light as the slab turns — the
  // system's light (up, right, toward the eye) and the tones of HALO's
  // graphite rim, dark at the body, a hairline of light at the lip. A part's
  // corner (a few pixels round) is one chord.
  const PR = .7, X3_LV = 24;   // (the parts' corner, .x3-p's --pr, in cqi)
  const LIGHT = (() => { const v = [.52, -.5, .69], m = Math.hypot(...v); return v.map((x) => x / m); })();
  const WALL = (() => {
    const mix = (a, b, t) => a.map((x, i) => Math.round(x + (b[i] - x) * t)), rgb = (c) => `rgb(${c.join(',')})`, out = [];
    for (let i = 0; i <= X3_LV; i++) {
      const d = i / X3_LV, base = mix([19, 20, 25], [54, 57, 67], Math.pow(d, 1.2));
      const back = mix(base, [8, 6, 22], .4), lip = mix(base, [246, 245, 252], Math.pow(d, 2.2) * .75);
      out.push(`linear-gradient(${rgb(back)},${rgb(base)} 68%,${rgb(base)} 91%,${rgb(lip)} 96%,${rgb(lip)})`);
    }
    return out;
  })();
  // (the walls' directions, out from the part: the four runs, then the
  // four corners' chords; the same for every part)
  const WALL_PHI = [-90, 0, 90, 180, -45, 45, 135, 225].map((a) => a * Math.PI / 180);
  const DEG = Math.PI / 180;
  const R3 = {
    x(a) { const c = Math.cos(a), s = Math.sin(a); return [1, 0, 0, 0, c, -s, 0, s, c]; },
    y(a) { const c = Math.cos(a), s = Math.sin(a); return [c, 0, s, 0, 1, 0, -s, 0, c]; },
    z(a) { const c = Math.cos(a), s = Math.sin(a); return [c, -s, 0, s, c, 0, 0, 0, 1]; },
    mul(A, B) { const r = new Array(9); for (let i = 0; i < 3; i++) for (let j = 0; j < 3; j++) r[i * 3 + j] = A[i * 3] * B[j] + A[i * 3 + 1] * B[3 + j] + A[i * 3 + 2] * B[6 + j]; return r; },
  };
  // (how much of the light a wall facing phi takes, the slab turned by M:
  // the system's rimLevel, less where it faces the eye)
  const wallLevel = (M, phi) => {
    const nx = Math.cos(phi), ny = Math.sin(phi);
    const qx = M[0] * nx + M[1] * ny, qy = M[3] * nx + M[4] * ny, qz = M[6] * nx + M[7] * ny;
    const l = Math.max(0, qx * LIGHT[0] + qy * LIGHT[1] + qz * LIGHT[2]) * (1 - .45 * Math.max(0, qz));
    return Math.round(clamp(.06 + .94 * l, 0, 1) * X3_LV);
  };
  // (a part's walls, w x h its size in cqi: the runs between its corners,
  // each a hair longer than its share so no seam shows where two meet, and
  // one chord across each corner, inscribed in the arc. Each stands on the
  // outline — its top edge there, turned up toward the eye — and is scaled
  // to the part's depth by --tk)
  function walls(p, w, h) {
    // (one chord a corner, inscribed in its quarter arc: its ends are the
    // runs' ends, where the arc meets the straight edges)
    const rr = PR * Math.cos(Math.PI / 4), cl = 2 * PR * Math.sin(Math.PI / 4), ov = .12;
    const at = (cx, cy, a) => [cx + rr * Math.cos(a), cy + rr * Math.sin(a)];
    const P = [[w / 2, 0, w - 2 * PR + ov], [w, h / 2, h - 2 * PR + ov], [w / 2, h, w - 2 * PR + ov], [0, h / 2, h - 2 * PR + ov],
      [...at(w - PR, PR, WALL_PHI[4]), cl + ov], [...at(w - PR, h - PR, WALL_PHI[5]), cl + ov], [...at(PR, h - PR, WALL_PHI[6]), cl + ov], [...at(PR, PR, WALL_PHI[7]), cl + ov]];
    p.walls = P.map(([cx, cy, len], j) => {
      const e = doc.createElement('i');
      e.className = 'x3-w';
      e.style.cssText = `left:${(cx - len / 2).toFixed(3)}cqi;top:${cy.toFixed(3)}cqi;width:${len.toFixed(3)}cqi;transform:rotateZ(${(WALL_PHI[j] + Math.PI / 2).toFixed(5)}rad) rotateX(90deg) scaleY(var(--tk, 0))`;
      p.el.insertBefore(e, p.pf);
      return { el: e, j, lv: -1 };
    });
  }
  function explode(el, o) {
    const E = D.engine, fc = $('.kit-fc', el), obj = o.objEl;
    if (!fc) return;
    const XS = haloX(el);   // THEME: the photographs' addresses
    const pct = (v, of) => `${(v / of * 100).toFixed(4)}%`;
    const place = (e, [x, y, w, h]) => Object.assign(e.style, { left: pct(x, FW), top: pct(y, FH), width: pct(w, FW), height: pct(h, FH) });
    const mk = (cls, parent) => { const e = doc.createElement('i'); e.className = cls; parent.appendChild(e); return e; };
    const dim = mk('x3-dim', fc);
    if (WK) el.classList.add('x3-wk');   // (r8: see "x3-wk" in the style)
    const parts = Object.keys(X3).map((key, i) => {
      const sock = mk('x3-s', fc); place(sock, X3[key]);
      const p = mk('x3-p', obj); place(p, X3[key]);
      p.innerHTML = '<i class="pb"><b></b></i><i class="pf"><b></b></i>';
      p.style.transform = HOME; p.lastChild.style.transform = FLUSH;
      const part = { key, i, el: p, sock, pf: p.lastChild, pic: p.lastChild.firstChild, L: key[0] === 'f' ? 'fx' : key, src: key === 'a' || key === 'b', css: HOME, fcss: FLUSH, on: false, wl: false, tk: -1, full: false };
      walls(part, X3[key][2] * 100 / FW, X3[key][3] * 100 / FW);   // (r8: its walls; the frame's pixels in cqi, the face 100 wide)
      return part;
    });
    {
      const sock = mk('x3-s rnd', fc); place(sock, X3_ORBS);
      const p = mk('x3-p orb', obj); place(p, X3_ORB);
      p.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" stroke-width="1.4"/><circle cx="8" cy="8" r="2.2" fill="currentColor"/><circle cx="12.6" cy="4.2" r="1.7" fill="currentColor"/></svg>';
      parts.push({ key: 'orb', i: parts.length, el: p, sock, L: 'orb', css: '', sh: '', on: false, orb: true });
    }
    const n = parts.length - 1;
    // the photographs: fetched, then worn; the parts are drawn at home only
    // once every one of them is in (before, the face alone shows there —
    // never an empty plate over it). A new set (another size) takes them
    // off home until it is in.
    let pk = 0;
    const setPics = (sc, scS) => {
      const tag = (v) => String(Math.round(v * 100)).padStart(3, '0'), me = ++pk;
      el.classList.remove('x3-rdy');
      const got = parts.filter((p) => p.pic).map((p) => {
        // THEME: the photograph's address from the section's map, never a built path
        const url = XS[`p-${p.key}-s1-${tag(p.src ? scS : sc)}`], im = new Image();
        if (!url) return Promise.reject(new Error(`halo-x: p-${p.key}`));
        p.pic.style.backgroundImage = `url("${url}")`;
        im.src = url;
        return im.decode ? im.decode() : new Promise((ok, no) => { im.onload = ok; im.onerror = no; });
      });
      Promise.all(got).then(() => { if (me === pk) el.classList.add('x3-rdy'); }, () => {});
    };
    let dimV = -1;
    const fx = {
      sc: 0, scS: 0, pics: false,
      layout() {
        const r = el.getBoundingClientRect();
        this.c = r.top + W.scrollY + r.height / 2;
        this.tall = E.vw <= 700;
        // (each part wears the photograph nearest above the size it is
        // drawn at, lifted a little nearer the eye. The two sources, wide
        // plates of small words lifted highest, are drawn twice over — into
        // their layer, then turned into the view — and a photograph only a
        // little larger than the screen's pixels came out soft on a 3x
        // phone: on a dense screen they wear one twice their size, sharp
        // after both passes, while the effects stay as they are)
        const dpr = W.devicePixelRatio || 1, need = r.width * o.s * dpr * 1.15 / FW;
        const pick = (v) => X3_SC.find((x) => x >= v) || X3_SC[X3_SC.length - 1];
        const sc = pick(need), scS = pick(need * (dpr >= 2 ? 2 : 1));
        if (sc !== this.sc || scS !== this.scS) { this.sc = sc; this.scS = scS; if (this.pics) setPics(sc, scS); }
      },
      // (fetched once the slab is near the screen)
      onSeen(on) { if (on && !this.pics) { this.pics = true; setPics(this.sc || 1.05, this.scS || this.sc || 1.05); } },
      frame(now, dt) {
        // c: where the slab's middle is on the screen (1 its foot, 0 its top).
        // Coming up (1 to .6): it turns from lying back to three quarters and
        // the parts lift, one after another; held apart (.6 to .4): a slow
        // turn; leaving (.38 to .08): the parts home, the orb first, and the
        // slab back to its reading angle.
        // (r8: through the speed cap, X3_RATE; at once while the slab is off
        // the screen, and on the first frame)
        const c0 = (this.c - E.S) / E.vh;
        if (this.cs === undefined || !dt || c0 > 1.25 || c0 < -.25) this.cs = c0;
        else this.cs += clamp(c0 - this.cs, -X3_RATE * dt, X3_RATE * dt);
        const c = this.cs, lag = Math.abs(c0 - c) > 1e-4;
        const A = seg(c, 1.02, .6), H = seg(c, .6, .4), Z = seg(c, .38, .08);
        const R = o.rest, P = X3_POSE[this.tall ? 'tall' : 'wide'], LF = X3_LIFT[this.tall ? 'tall' : 'wide'];
        const ea = ease(A), eh = smooth(H), ez = ease(Z);
        let rx = lerp(R.rx + 14, P.rx, ea), ry = lerp(R.ry + 6, P.ry, ea) + 7 * eh, rz = lerp(R.rz, P.rz, ea) + 5 * eh;
        rx = lerp(rx, R.rx, ez); ry = lerp(ry, R.ry, ez); rz = lerp(rz, R.rz, ez);
        const d = o.driver;
        if (!d || Math.abs(d.rx - rx) + Math.abs(d.ry - ry) + Math.abs(d.rz - rz) > .01) o.driver = { rx, ry, rz };
        // (r8) the light each wall direction takes, the slab as it is turned
        // now (the hand's turn too): worked out again only when the pose moves
        const g = o.drag || { p: 0, y: 0 }, pose = `${rx.toFixed(1)} ${ry.toFixed(1)} ${rz.toFixed(1)} ${(+g.p || 0).toFixed(1)} ${(+g.y || 0).toFixed(1)}`;
        if (pose !== this.pose) {
          this.pose = pose;
          const M = R3.mul(R3.mul(R3.mul(R3.x((+g.p || 0) * DEG), R3.y((+g.y || 0) * DEG)), R3.mul(R3.x(rx * DEG), R3.y(ry * DEG))), R3.z(rz * DEG));
          this.lvs = WALL_PHI.map((phi) => wallLevel(M, phi));
        }
        const lvs = this.lvs;
        for (const p of parts) {
          const up = ease(seg(A, .12 + p.i * .075, .5 + p.i * .07));
          const dn = ease(seg(Z, (n - p.i) * .06, .5 + (n - p.i) * .06));
          const k = up * (1 - dn), on = k * LF[p.L] > .02, L = on ? k * LF[p.L] : 0;
          if (on !== p.on) { p.on = on; p.el.classList.toggle('up', on); p.sock.classList.toggle('on', on); }
          if (p.orb) {
            // (its shadow on the face: there within a hair of its rise, then
            // wider and fainter as it goes up)
            const sh = on ? `${clamp(L / 2, 0, 1).toFixed(2)} ${k.toFixed(2)}` : '0 0';
            if (sh !== p.sh) { p.sh = sh; const [a, b] = sh.split(' '); p.sock.style.setProperty('--sh', a); p.sock.style.setProperty('--so', b); }
            if (!on) continue;
            const css = `translate3d(0,0,calc(var(--d) / 2 + ${(.05 + L).toFixed(2)}cqi${WK ? ' + 1px' : ''})) scale(${((1 + (this.tall ? 1.6 : 1) * k) / 3).toFixed(3)})`;
            if (css !== p.css) { p.css = css; p.el.style.transform = css; }
            continue;
          }
          // (its body never goes through the face: it rises from the face as
          // the part does, to its full thickness; at home, a hair over it.
          // r8, WebKit: a pixel over it, see "x3-wk")
          const css = on ? `translate3d(0,0,calc(var(--d) / 2 + ${(.05 + Math.max(0, L - PT)).toFixed(2)}cqi${WK ? ' + 1px' : ''}))` : HOME, fcss = on ? `translate3d(0,0,${Math.min(L, PT).toFixed(2)}cqi)` : FLUSH;
          if (css !== p.css) { p.css = css; p.el.style.transform = css; }
          if (fcss !== p.fcss) { p.fcss = fcss; p.pf.style.transform = fcss; }
          // (r8) its walls, as deep as its face stands over its body (in
          // hundredths of its thickness; none under a twelfth of it), and
          // its body only once it has its whole thickness (see "x3-wk")
          const tk = on ? Math.round(Math.min(L, PT) / PT * 100) / 100 : 0, wl = tk >= .08, full = on && L >= PT;
          if (wl !== p.wl) { p.wl = wl; p.el.classList.toggle('wl', wl); }
          if (full !== p.full) { p.full = full; p.el.classList.toggle('full', full); }
          if (wl) {
            if (tk !== p.tk) { p.tk = tk; p.el.style.setProperty('--tk', String(tk)); }
            for (const w of p.walls) { const lv = lvs[w.j]; if (lv !== w.lv) { w.lv = lv; w.el.style.backgroundImage = WALL[lv]; } }
          }
        }
        // the face a step down while the parts are apart (in sixteenths: the
        // face is painted again only when it changes. r8, WebKit: the dim is a
        // layer of its own there, faded in fine steps without painting the face)
        const v0 = ease(seg(A, .1, .55)) * (1 - ease(seg(Z, .15, .75))), v = WK ? Math.round(v0 * 64) / 64 : Math.round(v0 * 16) / 16;
        if (v !== dimV) { dimV = v; dim.style.opacity = (v * .46).toFixed(3); }
        return lag;
      },
    };
    D.register(fx, el, true);
    fx.frame();
    if (o.driver) { o.lastT = ''; o.write(o.driver.rx, o.driver.ry, o.driver.rz); }
  }

  // subforge: its output — an 808 (its own drawing, at c1) and, under it,
  // the envelope that shapes it (a shaded area with its three handles)
  if (D.DRAW) D.DRAW.sf = ({ S, T, Dt, A, G }) => {   // THEME: guarded (DRAW is the system's)
    S(G.rr(8, 8, 584, 176, 12), 0, .18, 'lt');
    T(28, 36, '808 · c1 · 32.7 hz', .1, .2, 's');
    const V = [32, 20.8, 12.4, 8.4, 9.3, 14.5, 22.9, 32.5, 41.5, 48.2, 51.6, 51.2, 47.3, 41, 33.4, 26, 20.1, 16.5, 15.7, 17.6, 21.9, 27.5, 33.5, 39, 43, 45.2, 45.2, 43.2, 39.6, 35.2, 30.5, 26.3, 23.2, 21.4, 21.2, 22.5, 25, 28.3, 31.9, 35.3, 38, 39.9, 40.7, 40.4, 39.1, 37, 34.4, 31.8, 29.3, 27.2, 25.8, 25.2, 25.3, 26.1, 27.5, 29.3, 31.2, 33.1, 34.8, 36.1, 37, 37.3, 37.2, 36.5, 35.5, 34.3, 32.9, 31.6, 30.3, 29.3, 28.5, 28.1, 28, 28.2, 28.6, 29.4, 30.2, 31.1, 32.1, 32.9, 33.7, 34.3, 34.7, 34.9, 35, 34.8, 34.5, 34, 33.5, 32.9, 32.3, 31.7, 31.2, 30.7, 30.4, 30.1, 29.9, 29.9, 29.9, 30.1, 30.3, 30.6, 30.9, 31.2, 31.6, 31.9, 32.3, 32.6, 32.8, 33, 33.2, 33.3, 33.4, 33.4, 33.4, 33.3, 33.2, 33.1, 32.9, 32.7, 32.6];
    const X = (x) => 28 + x * 544 / 300, Y = (v) => 108 + (v - 32) * 2.1;
    const env = [[4, 54], [34, 10], [96, 26], [232, 34], [292, 54]].map(([x, v]) => [X(x), Y(v)]);
    const base = Y(54);
    A(`${G.poly(env)}Z`, .12, .3);
    S(G.poly(env), .14, .34, 'lt');
    T(28, base + 17, 'envelope', .28, .4, 's');
    S(G.poly(V.map((v, i) => [X(i * 2.5), Y(v)])), .3, .76);
    env.slice(1, 4).forEach(([x, v], j) => { S(G.ring(x, v, 4.2), .7 + j * .04, .78 + j * .04); Dt(x, v, 4.2, .78 + j * .04, .84 + j * .04); });
    S(`M${G.f1(X(262))} 50V${G.f1(base)}`, .84, .96, 'lt');
    T(X(262), base + 17, '1.76 s', .9, 1, 's', 'middle');
  };

  // the phrase keeps one size on its three lines: the widest is brought
  // down just enough to stay inside the column (at layout time only)
  // THEME: one phrase per hero section, each keeping the width it was
  // fitted at on itself (p._fitW)
  const PHRASES = new Set();
  function fitPhrase(p, force) {
    if (!p) return;
    const w = root.clientWidth;
    if (!force && w === p._fitW) return;
    p._fitW = w;
    p.style.removeProperty('--hf');
    const room = p.clientWidth, need = Math.max(...$$('.hx-l .w', p).map((x) => x.offsetWidth));
    if (need > room && room > 0) p.style.setProperty('--hf', (Math.floor(room / need * 1000) / 1000 - .004).toFixed(3));
  }
  W.addEventListener('resize', () => {
    let moved = false;
    for (const p of PHRASES) {
      if (!p.isConnected) { PHRASES.delete(p); continue; }
      if (root.clientWidth !== p._fitW) { fitPhrase(p, false); moved = true; }
    }
    if (moved) D.layout();
  });

  // THEME: the slab's face, where it comes apart, is the landing's own
  // photograph (halo-x-s1-*), the one its parts are cut from: drawn at home
  // a hair over the face, they lie exactly on the same picture (the
  // system's halo-face.webp is another shot of it). Put in the <img> the
  // section printed before the system adopts it (lazy: nothing fetched yet).
  // (the <img> as printed, or already in the face once the object is built:
  // a section reloaded in the theme's editor is built before its init runs)
  const FACE = [['s1-080', 960], ['s1-105', 1260], ['s1-140', 1680], ['s1-200', 2400]];
  function face(k) {
    const img = $(':scope > img', k) || $('.kit-fc img', k), XS = haloX(k);
    if (!img || !XS['s1-105'] || /halo-x-s1-/.test(img.getAttribute('src') || '')) return;
    img.srcset = FACE.filter(([s]) => XS[s]).map(([s, w]) => `${XS[s]} ${w}w`).join(', ');
    img.src = XS['s1-105'];
    img.width = 2400; img.height = 1484;
    if (!img.getAttribute('sizes')) img.sizes = '(min-width: 861px) min(1000px, 64vw), (min-width: 701px) min(1200px, 90vw), 94vw';
  }
  $$('[data-x3]').forEach(face);

  // (a phone: the slab as wide as its plate lets it be, so its parts read
  // apart — set before the system builds it, at DOMContentLoaded. And
  // drawn at twice its size (K 2, r7): turned in its pose, its face was
  // drawn soft on a 3x phone — the header, the blend, the keys unreadable
  // — where the same picture laid flat is sharp. Not where WebKit draws
  // (Safari, any iPhone browser): the system keeps K at 1 there, see superK)
  // THEME: every slab that comes apart (data-x3), not only the page's first
  for (const hk0 of $$('[data-x3]')) {
    if (!W.matchMedia('(max-width: 700px)').matches) break;
    hk0.dataset.scale = '.87';
    if (!WK) hk0.dataset.k = '2';
  }

  // THEME: the hero, one section: what the page's 'home' init did for the
  // phrase, its object and "latest release", now for each hero under the
  // init's scope, once each
  function hero(hx) {
    const E = D.engine;
    const p = $('.hx-p', hx);
    if (p) { PHRASES.add(p); fitPhrase(p, true); }
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(() => { if (p && p.isConnected) { fitPhrase(p, true); D.layout(); } });
    // the phrase is uncovered as the page opens (two frames, then CSS alone)
    if (root.classList.contains('mo')) W.requestAnimationFrame(() => W.requestAnimationFrame(() => hx.classList.add('in')));

    // "latest release": to the release card, under the top line
    for (const a of $$('[data-to-release]', hx)) {
      a.addEventListener('click', (e) => {
        const t = $('#release .rel'); if (!t) return;
        e.preventDefault();
        const y = W.scrollY + t.getBoundingClientRect().top - (E.hh || 56) - 10;
        W.scrollTo({ top: Math.max(0, y), behavior: E.on ? 'smooth' : 'auto' });
        const h = $('.nm', t); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }   // THEME: the card's name, by its class
      });
    }
    if (!E.on) return;

    // the phrase's object: it comes round to face the page once as the page
    // opens, and lies back on the table as the page leaves it (read off the
    // scroll, both ways; it never leaves its place). Before its own frame.
    const k0 = $('[data-hx-obj]', hx), o0 = k0 && k0._obj;
    if (o0) {
      D.register({
        frame() {
          const e = ease(seg(E.S, 0, E.vh * .8));
          if (!e) { if (o0.driver) { o0.driver = null; o0.hot = true; } return false; }
          const rx = o0.rest.rx + 38 * e;
          if (!o0.driver || Math.abs(o0.driver.rx - rx) > .01) o0.driver = { rx, ry: o0.rest.ry + 14 * e, rz: o0.rest.rz - 5 * e };
          return false;
        },
      }, k0, true);
      if (!W.scrollY) { o0.intro = { t0: performance.now(), dur: 1500 }; o0.hot = true; }
      // its cover goes round the kits (data-cycle: a half turn each, the
      // face becoming the next kit's edge-on; only while it is on the
      // screen and the tab shown — a timer waits between two turns, no
      // frame). A hand stops it (the system's rule); left alone a few
      // seconds, it goes on from the kit the hand left.
      const list = (k0.dataset.cycle || '').trim().split(/\s+/), every = +k0.dataset.cycleEvery || 3800;
      // (and it turns only where it is really seen: the system's watch
      // reaches a third of a screen past the edges, where a turn would be
      // frames for nothing — out of view it waits, back in view it goes on)
      const sc = o0.scene; let again = 0, held = false, vis = true, watch = null;
      const go = (delay) => { if (vis && !held && !o0.cyc && !o0.drag.mode) o0.cycle(list, { every, rounds: 0, delay }); };
      const later = () => { clearTimeout(again); held = true; again = setTimeout(() => { held = false; go(2600); }, 4200); };
      if (list.length > 1 && sc) {
        sc.addEventListener('pointerdown', () => clearTimeout(again));
        for (const t of ['pointerup', 'pointercancel', 'keyup', 'blur']) sc.addEventListener(t, later);
        if ('IntersectionObserver' in W) {
          watch = new IntersectionObserver((es) => {
            for (const e of es) { vis = e.isIntersecting; if (!vis) o0.stopCycle(); else go(1800); }
          }, { threshold: .4 });
          watch.observe(k0);
        }
      }
      // THEME: taken out in the theme's editor, it lets its timer and its
      // watch go (the system stops the cycle itself: unmount)
      hx._hxOff = () => { clearTimeout(again); held = true; vis = false; if (watch) watch.disconnect(); };
    }
  }
  doc.addEventListener('shopify:section:unload', (e) => {
    for (const hx of within(e.target, '.hx[data-hero]')) if (hx._hxOff) hx._hxOff();
  });

  // THEME: the page's one 'home' init, split by section (each runs at the
  // start with the document, and again with its section when the theme's
  // editor reloads it)
  D.section('hero', (scope) => {
    for (const hx of within(scope, '.hx[data-hero]')) {
      if (hx._hx) continue;
      hx._hx = true;
      hero(hx);
    }
    D.wake();
  });

  // HALO, coming apart (see "halo, coming apart" in the style)
  D.section('halo', (scope) => {
    within(scope, '[data-x3]').forEach(face);   // THEME: (a slab reloaded in the editor)
    if (!D.engine.on) return;
    for (const hk of within(scope, '[data-x3]')) {
      const ho = hk._obj;
      if (hk._x3 || !ho || !ho.objEl) continue;
      hk._x3 = true;
      explode(hk, ho);
    }
    D.wake();
  });

  // THEME: subforge's drawing is added above, before the system starts; if
  // the system had started first, its drawing is mounted here, once
  D.section('deal', (scope) => {
    for (const svg of within(scope, 'svg[data-draw="sf"]')) {
      if (!svg.firstElementChild && D.DRAW && D.DRAW.sf) D.mount(svg.parentElement);
    }
  });
})();
